import { _ as __assign } from '../../chunks/bundle-BsoKutlt.js';
import React__default from 'react';
import { g as getSuggestedReplies } from '../../chunks/bundle-ChbTBhrO.js';
import { M as MessageInputWrapperView } from '../../chunks/bundle-Lpom0rRJ.js';
import { useChannelContext } from '../context.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CtiWV1fp.js';
import '../../chunks/bundle-CAw7uZEI.js';
import '../../chunks/bundle-BXx8qybA.js';
import '../../chunks/bundle-D9fAlnnY.js';
import '../../chunks/bundle-K-ZPPQr-.js';
import '../../GroupChannel/components/SuggestedMentionList.js';
import '../../chunks/bundle-D8_eHC2p.js';
import '../../chunks/bundle-C8lF82nA.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-By8wnYCK.js';
import '../../chunks/bundle-DFFEB3Ap.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Bpnh459j.js';
import '../../chunks/bundle-Bect-58W.js';
import '../../chunks/bundle-Cdxj4urY.js';
import '../../chunks/bundle-CkidI9AN.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-SmYaD8k7.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-BnF3HgAG.js';
import '../../chunks/bundle-BsRE6o7w.js';
import '../../VoiceRecorder/context.js';
import '../../chunks/bundle-CoaHGciJ.js';
import 'react-dom';
import '../../chunks/bundle-DleO6yp8.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../withSendbird.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-DF417z4S.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CLhORKfu.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-wZ2MFfjI.js';
import 'dompurify';
import '../../chunks/bundle-BmxObDcu.js';
import '../../chunks/bundle-rcslTaFE.js';
import '../../chunks/bundle-BrGYoMhP.js';
import '../../chunks/bundle-CuhsrQeV.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CDD1VVKm.js';
import '../../chunks/bundle-DDQiHUtN.js';
import '../../chunks/bundle-Qz21XT9v.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-B_S6iTLS.js';
import '../../chunks/bundle-DqiG00CL.js';
import '../../chunks/bundle-Dcu4oaT9.js';
import '../../chunks/bundle-SFTC4POJ.js';
import '../../chunks/bundle-JoxrNKuk.js';
import '../../chunks/bundle-D8tzsrR-.js';
import '../../chunks/bundle-B-5tutOE.js';
import '../../chunks/bundle-B0uMDJtX.js';
import '../../chunks/bundle-BmAH27TX.js';
import '../../chunks/bundle-CKHpBJK8.js';

var MessageInputWrapper = function (props) {
    var _a, _b;
    var config = useSendbirdStateContext().config;
    var context = useChannelContext();
    var quoteMessage = context.quoteMessage, localMessages = context.localMessages, currentGroupChannel = context.currentGroupChannel, sendMessage = context.sendMessage, sendFileMessage = context.sendFileMessage, sendVoiceMessage = context.sendVoiceMessage, sendMultipleFilesMessage = context.sendMultipleFilesMessage;
    var lastMessage = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.lastMessage;
    var isLastMessageSuggestedRepliesEnabled = ((_a = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _a === void 0 ? void 0 : _a.enableSuggestedReplies)
        && getSuggestedReplies(lastMessage).length > 0
        && (localMessages === null || localMessages === void 0 ? void 0 : localMessages.length) === 0;
    var disableMessageInput = props.disabled
        || isLastMessageSuggestedRepliesEnabled && !!((_b = lastMessage.extendedMessagePayload) === null || _b === void 0 ? void 0 : _b['disable_chat_input']);
    return (React__default.createElement(MessageInputWrapperView, __assign({}, props, context, { disabled: disableMessageInput, currentChannel: currentGroupChannel, sendUserMessage: function (params) {
            return sendMessage({
                message: params.message,
                mentionTemplate: params.mentionedMessageTemplate,
                mentionedUsers: params.mentionedUsers,
                quoteMessage: quoteMessage,
            });
        }, sendFileMessage: function (params) {
            return sendFileMessage(params.file, quoteMessage);
        }, sendVoiceMessage: function (_a, duration) {
            var file = _a.file;
            return sendVoiceMessage(file, duration, quoteMessage);
        }, sendMultipleFilesMessage: function (_a) {
            var fileInfoList = _a.fileInfoList;
            return sendMultipleFilesMessage(fileInfoList.map(function (fileInfo) { return fileInfo.file; }), quoteMessage);
        } })));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInput.js.map
